<script setup lang="ts">
import { PhCaretLeft, PhCopy } from "@phosphor-icons/vue";
</script>

<template>
  <section id="productInfoView" class="product-info-view" aria-labelledby="productInfoViewTitle" hidden>
    <header class="view-header">
      <button id="productInfoBackButton" class="icon-button" type="button" aria-label="返回素材总览">
        <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
      </button>
      <div class="view-title-group">
        <h2 id="productInfoViewTitle">商品信息</h2>
        <span id="productInfoCapturedAt">采集快照</span>
      </div>
    </header>

    <div id="productInfoDetailScroll" class="product-info-detail-scroll" tabindex="0">
      <section id="productInfoBasicGroup" class="product-info-detail-group" hidden>
        <div class="product-info-detail-heading">
          <h3>基础信息</h3>
          <button id="productInfoBasicCopyButton" class="product-info-copy-button" type="button" aria-label="复制基础信息">
            <PhCopy :size="14" weight="bold" aria-hidden="true" />
            <span>复制</span>
          </button>
          <span id="productInfoBasicCopyStatus" class="visually-hidden" role="status" aria-live="polite" aria-atomic="true"></span>
        </div>
        <dl id="productInfoBasicList" class="product-info-detail-list"></dl>
      </section>

      <section id="productInfoAttributesGroup" class="product-info-detail-group" hidden>
        <div class="product-info-detail-heading">
          <h3>商品属性</h3>
          <button id="productInfoAttributesCopyButton" class="product-info-copy-button" type="button" aria-label="复制商品属性">
            <PhCopy :size="14" weight="bold" aria-hidden="true" />
            <span>复制</span>
          </button>
          <span id="productInfoAttributesCopyStatus" class="visually-hidden" role="status" aria-live="polite" aria-atomic="true"></span>
        </div>
        <dl id="productInfoAttributesList" class="product-info-detail-list"></dl>
      </section>

      <section id="productInfoFulfillmentGroup" class="product-info-detail-group" hidden>
        <div class="product-info-detail-heading">
          <h3>包装与履约</h3>
          <button id="productInfoFulfillmentCopyButton" class="product-info-copy-button" type="button" aria-label="复制包装与履约">
            <PhCopy :size="14" weight="bold" aria-hidden="true" />
            <span>复制</span>
          </button>
          <span id="productInfoFulfillmentCopyStatus" class="visually-hidden" role="status" aria-live="polite" aria-atomic="true"></span>
        </div>
        <p id="productInfoFulfillmentTime" class="product-info-snapshot-time"></p>
        <dl id="productInfoFulfillmentList" class="product-info-detail-list"></dl>
      </section>

      <section id="productInfoSkuGroup" class="product-info-detail-group" hidden>
        <div class="product-info-detail-heading">
          <h3>SKU 明细</h3>
          <button id="productInfoSkuCopyButton" class="product-info-copy-button" type="button" aria-label="复制 SKU 明细">
            <PhCopy :size="14" weight="bold" aria-hidden="true" />
            <span>复制</span>
          </button>
          <span id="productInfoSkuCopyStatus" class="visually-hidden" role="status" aria-live="polite" aria-atomic="true"></span>
        </div>
        <p id="productInfoSkuNote" class="product-info-context-note" hidden></p>
        <div id="productInfoSkuList" class="product-info-sku-list"></div>
      </section>

      <section id="productInfoSupplierGroup" class="product-info-detail-group" hidden>
        <div class="product-info-detail-heading">
          <h3>供应商快照</h3>
          <button id="productInfoSupplierCopyButton" class="product-info-copy-button" type="button" aria-label="复制供应商快照">
            <PhCopy :size="14" weight="bold" aria-hidden="true" />
            <span>复制</span>
          </button>
          <span id="productInfoSupplierCopyStatus" class="visually-hidden" role="status" aria-live="polite" aria-atomic="true"></span>
        </div>
        <p id="productInfoSupplierTime" class="product-info-snapshot-time"></p>
        <dl id="productInfoSupplierList" class="product-info-detail-list"></dl>
      </section>

      <section id="productInfoMarketGroup" class="product-info-detail-group" hidden>
        <div class="product-info-detail-heading">
          <h3>市场信号</h3>
          <button id="productInfoMarketCopyButton" class="product-info-copy-button" type="button" aria-label="复制市场信号">
            <PhCopy :size="14" weight="bold" aria-hidden="true" />
            <span>复制</span>
          </button>
          <span id="productInfoMarketCopyStatus" class="visually-hidden" role="status" aria-live="polite" aria-atomic="true"></span>
        </div>
        <p id="productInfoMarketTime" class="product-info-snapshot-time"></p>
        <dl id="productInfoMarketList" class="product-info-detail-list"></dl>
      </section>

      <p id="productInfoEmptyState" class="product-info-empty-state" hidden>
        当前页面暂未获取到可展示的商品信息。
      </p>
    </div>
  </section>
</template>
